import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

import { IsLoggedGuard } from './shared/guards/is-logged.guard';

const appRoutes: Routes = [
  { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'request',
    loadChildren: () => import('./request/request.module').then(m => m.RequestModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'development',
    loadChildren: () => import('./development/development.module').then(m => m.DevelopmentModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then(m => m.OrderModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'warehouse',
    loadChildren: () => import('./warehouse/warehouse.module').then(m => m.WarehouseModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'employee',
    loadChildren: () => import('./employee/employee.module').then(m => m.EmployeeModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'production-plan',
    loadChildren: () => import('./production-plan/production-plan.module').then(m => m.ProductionPlanModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'development-plan',
    loadChildren: () => import('./development-plan/development-plan.module').then(m => m.DevelopmentPlanModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'job-list',
    loadChildren: () => import('./job-list/job-list.module').then(m => m.JobListModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'shift-stats',
    loadChildren: () => import('./shift-stats/shift-stats.module').then(m => m.ShiftStatsModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'sector',
    loadChildren: () => import('./sector/sector.module').then(m => m.SectorModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'report',
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'procurement',
    loadChildren: () => import('./procurement/procurement.module').then(m => m.ProcurementModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'product',
    loadChildren: () => import('./product/product.module').then(m => m.ProductModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'logistics',
    loadChildren: () => import('./logistics/logistics.module').then(m => m.LogisticsModule),
    canActivate: [IsLoggedGuard]
  },
  {
    path: 'document-checker',
    loadChildren: () => import('./document-checker/document-checker.module').then(m => m.DocumentCheckerModule),
    canActivate: [IsLoggedGuard]
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
